import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Collapsable } from '../../../Collapsable';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation, FeatureToggleInformation } from '../common';

interface LotFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function LotFeatureTogglesView({ company, update }: LotFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.lots;

  return (
    <Collapsable
      open={toggles.lots}
      header={
        <FeatureToggleItem value={toggles.lots} onChange={async value => update(copy.withLotsFeatureToggle(value))}>
          <FeatureToggleTitle text={t(TranslationKey.lotLotFeatureToggleTitle).singular.upper} />
          <FeatureToggleExplanation text={t(TranslationKey.lotLotFeatureToggleExplanation).singular.upper} />
          <FeatureToggleInformation text={t(TranslationKey.lotLotFeatureToggleInformation).singular.upper} />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.lotUniqueCompany}
        onChange={async value => update(copy.withLotUniqueCompanyFeatureToggle(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.lotLotsUniqueWithinCompanyFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation
          text={t(TranslationKey.lotLotsUniqueWithinCompanyFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
      <FeatureToggleItem
        indent={1}
        value={toggles.lotUniqueProductMasterData}
        onChange={async value => update(copy.withLotUniqueProductMasterDataFeatureToggle(value))}
      >
        <FeatureToggleTitle
          text={t(TranslationKey.lotLotsUniqueForProductReferenceDataFeatureToggleTitle).singular.upper}
        />
        <FeatureToggleExplanation
          text={t(TranslationKey.lotLotsUniqueForProductReferenceDataFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
      <FeatureToggleItem
        indent={1}
        value={toggles.expiryManagement}
        onChange={async value => update(copy.withLotExpiryManagementFeatureToggle(value))}
      >
        <FeatureToggleTitle text={t(TranslationKey.lotLotsExpiryManagementFeatureToggleTitle).singular.upper} />
        <FeatureToggleExplanation
          text={t(TranslationKey.lotLotsExpiryManagementFeatureToggleExplanation).singular.upper}
        />
      </FeatureToggleItem>
    </Collapsable>
  );
}
